(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65],{

/***/ 24414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailLogin; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50319);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88641);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24824);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50261);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2453);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42561);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61373);
/* harmony import */ var _contexts_authToken__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43911);
/* harmony import */ var graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13492);
/* harmony import */ var redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64515);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var FormItem = antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item;
var validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label} is required!',
  types: {
    // eslint-disable-next-line no-template-curly-in-string
    email: '${label} is not valid!'
  }
};
function EmailLogin(_ref) {
  var callbackbeforeRedirect = _ref.callbackbeforeRedirect;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userEmail = _useState[0],
      setuserEmail = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userPassword = _useState2[0],
      setuserPassword = _useState2[1];

  var _useMutation = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Login_MutationDocument */ .Q0),
      _useMutation2 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation, 2),
      Login = _useMutation2[0],
      data = _useMutation2[1].data;

  if (data) {
    if (callbackbeforeRedirect) {
      callbackbeforeRedirect();
    } else {
      (0,redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__.addSuccess)({
        text: 'Registration Successfull'
      });
      next_router__WEBPACK_IMPORTED_MODULE_2___default().push('/');
    }
  }

  var token = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_authToken__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  var setToken = token.setToken;

  var _useMutation3 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Update_UserDocument */ .xU),
      _useMutation4 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation3, 1),
      updateUser = _useMutation4[0];

  var formItemLayout = {
    wrapperCol: {
      span: 32
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread(_objectSpread({
      name: "basic",
      layout: "vertical"
    }, formItemLayout), {}, {
      className: "login-form",
      onFinish: function onFinish() {
        Login({
          variables: {
            input: {
              identifier: userEmail,
              password: userPassword
            }
          }
        }).then(function (res) {
          localStorage.setItem('authToken', res.data.login.jwt);
          localStorage.setItem('userEmail', res.data.login.user.email);
          localStorage.setItem('userId', res.data.login.user.id);
          setToken(res.data.login.jwt);
          updateUser({
            context: {
              headers: {
                Authorization: "Bearer ".concat(res.data.login.jwt)
              }
            }
          })["catch"](function (err) {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('---update err----', err);
          });
        })["catch"](function (error) {
          if (error.message === 'GraphQL error: Bad Request') {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Invalid Email or Password');
          } else {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Sorry Something Went Wrong!');
          }
        });
      },
      validateMessages: validateMessages,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        label: "Email Address",
        name: "email",
        rules: [{
          required: true,
          type: 'email'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
          placeholder: "john.doe@gmail.com",
          autoComplete: "off",
          autoFocus: true,
          onChange: function onChange(e) {
            setuserEmail(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        name: "password",
        label: "Password",
        rules: [{
          required: true,
          message: 'Please input your Password!'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Password */ .Z.Password, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          placeholder: "Password",
          onChange: function onChange(e) {
            setuserPassword(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({
        className: "m-b-0"
      }, formItemLayout), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_shared_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          type: "primary",
          size: "middle",
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          className: "auth--button--login",
          htmlType: "submit",
          source: "email-login",
          children: "Login Now"
        })
      }))]
    }))
  });
}

/***/ }),

/***/ 90635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SocialLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62307);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24126);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var providersIcon = {
  facebook: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
    label: "SignIn with Facebook"
  },
  google: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
    label: "SignIn with Google"
  }
};
function SocialLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    className: "linksContainer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      span: "24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          type: "primary",
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/facebook"),
          style: {
            width: '100%'
          },
          className: "facebook",
          source: "facebook-login",
          children: [providersIcon.facebook.icon, providersIcon.facebook.label]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/google"),
          type: "primary",
          style: {
            width: '100%'
          },
          className: "google",
          source: "google-login",
          children: [providersIcon.google.icon, providersIcon.google.label]
        })
      })]
    })
  });
}

/***/ }),

/***/ 98636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96074);
/* harmony import */ var _components_auth_EmailLogin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24414);
/* harmony import */ var _components_auth_SocialLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90635);
/* harmony import */ var layouts_application__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8182);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var Title = antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Title */ .Z.Title,
    Paragraph = antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Paragraph */ .Z.Paragraph;

var renderLink = function renderLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/auth/forgot-password",
      children: "Forgot Password"
    }), "\xA0or\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/auth/register",
      children: "Register"
    })]
  });
};

var AuthPage = function AuthPage(props) {
  var divStyle = {
    marginTop: '32px'
  };
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.nav_calculators.data,
      allPages = pageData.all_pages.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(layouts_application__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      className: "authPage",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        span: "24",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Title, {
          level: 2,
          children: "Login to your Account."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Paragraph, {
          children: "Please enter your details to login."
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: "formContainer",
        style: divStyle,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          span: "24",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "row",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              span: "24",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_auth_SocialLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: "or"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_auth_EmailLogin__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "linkContainer",
            children: renderLink()
          })]
        })
      })]
    })
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (AuthPage);

/***/ }),

/***/ 37265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin",
      function () {
        return __webpack_require__(98636);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2769,6568,8182,3492,9774,2888,179], function() { return __webpack_exec__(37265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);